"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.APosCustomerOwnedBottleUpdateInputSchema = exports.APosCustomerOwnedBottleCreateInputSchema = exports.APosCustomerOwnedBottleSchema = exports.APosCustomerOwnedBottleConditionSchema = void 0;
const zod_1 = require("zod");
const id_schema_1 = require("../../common/id.schema");
/**
 * Module 29 — Oil Blending — BYOB ("Bring Your Own Bottle").
 * CustomerOwnedBottle — which refillable bottles a customer owns.
 * PK = tenantId, SK = ownedBottleId (cob_{ulid12}).
 * GSI: customer-index (tenantId + customer_id).
 *
 * Idempotency anchor: (customer_id, bottle_id, source_sale_id) composite —
 * analytics consumer upserts off this.
 */
const decimal3dp = (val) => Number.isFinite(val) && Math.round(val * 1000) / 1000 === val;
exports.APosCustomerOwnedBottleConditionSchema = zod_1.z.enum([
    'good', 'damaged', 'lost', 'donated',
]);
exports.APosCustomerOwnedBottleSchema = zod_1.z.object({
    tenantId: id_schema_1.TenantIdSchema,
    ownedBottleId: id_schema_1.EntityIdSchema.describe('Format: cob_{ulid12}'),
    customer_id: id_schema_1.EntityIdSchema,
    bottle_id: id_schema_1.EntityIdSchema.describe('FK to Bottle catalog'),
    size_ml: zod_1.z.number().positive().refine(decimal3dp, 'must be 3dp').describe('Denormalised for fast read'),
    source_sale_id: id_schema_1.EntityIdSchema.describe('Original purchase — idempotency anchor'),
    acquired_at: zod_1.z.string().describe('ISO date'),
    refilled_count: zod_1.z.number().int().nonnegative().default(0),
    last_refilled_at: zod_1.z.string().optional().describe('ISO date'),
    condition: exports.APosCustomerOwnedBottleConditionSchema.default('good'),
    notes: zod_1.z.string().max(2000).optional(),
    is_active: zod_1.z.boolean().default(true),
});
exports.APosCustomerOwnedBottleCreateInputSchema = zod_1.z.object({
    customer_id: id_schema_1.EntityIdSchema,
    bottle_id: id_schema_1.EntityIdSchema,
    size_ml: zod_1.z.number().positive().refine(decimal3dp, 'must be 3dp'),
    source_sale_id: id_schema_1.EntityIdSchema,
    acquired_at: zod_1.z.string(),
    condition: exports.APosCustomerOwnedBottleConditionSchema.optional(),
    notes: zod_1.z.string().max(2000).optional(),
});
exports.APosCustomerOwnedBottleUpdateInputSchema = zod_1.z.object({
    refilled_count: zod_1.z.number().int().nonnegative().optional(),
    last_refilled_at: zod_1.z.string().optional(),
    condition: exports.APosCustomerOwnedBottleConditionSchema.optional(),
    notes: zod_1.z.string().max(2000).optional(),
    is_active: zod_1.z.boolean().optional(),
});
//# sourceMappingURL=customer-owned-bottle.schema.js.map